import { render, staticRenderFns } from "./AppLightbox.vue?vue&type=template&id=0caf8379&scoped=true&"
import script from "./AppLightbox.vue?vue&type=script&lang=js&"
export * from "./AppLightbox.vue?vue&type=script&lang=js&"
import style0 from "./AppLightbox.vue?vue&type=style&index=0&id=0caf8379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf8379",
  null
  
)

export default component.exports